import { useEffect } from "react";
import { Link } from "react-router";

/**
 * A 404 item. Partners get wording identical for a missing item and an internal one (UX-01 4.8); the wording
 * depends only on who is looking, never on what exists.
 *
 * The API's problem-code set is closed (R21): every one of "doesn't exist", "was deleted", and "you're not a
 * project member" comes back as the same 404 `not-found`, with no field distinguishing which. Earlier copy here
 * enumerated those causes and told the user to "ask the project manager for access" as if permission were the
 * confirmed reason — wrong whenever the real cause is something else the API also can't tell us about (e.g. a
 * client hitting a route that isn't implemented yet gets the identical `not-found`). Say only what the response
 * actually establishes: the item could not be found for this viewer, cause unconfirmed.
 */
export function ItemNotAvailable({ partner }: { partner: boolean }) {
  useEffect(() => {
    document.title = "Item not available · Giraffe";
  }, []);
  return (
    <div className="gf-pagehead">
      <h1>Item not available</h1>
      <p className="sub">
        {partner
          ? "It may not exist, or may not be shared with partner staff."
          : "It may not exist, or you may not have access to it."}{" "}
        <Link to="/">Go to Home</Link>
      </p>
    </div>
  );
}

export function PageNotAvailable({ title, reason }: { title: string; reason: string }) {
  useEffect(() => {
    document.title = `${title} · Giraffe`;
  }, [title]);
  return (
    <div className="gf-pagehead">
      <h1>{title}</h1>
      <p className="sub">
        {reason} <Link to="/">Go to Home</Link>
      </p>
    </div>
  );
}
